<template>
  <div class="packaging-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="packaging-content">
      <p class="packaging-p indent">Alcomet ha una forte presenza sul mercato europeo.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_1.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-1">Foglio per la conservazione domestica degli alimenti (HHF)</h4>
      <p class="packaging-p indent">Il foglio per uso domestico viene utilizzato per avvolgere gli alimenti durante la cottura o per preservarne la freschezza. La sua eccellente resistenza alle alte temperature in cucina, nonché il suo ruolo di barriera contro la luce, l'aroma e il vapore ne fanno un elemento essenziale in ogni cucina.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_2.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-2">Foglio per contenitori </h4>
      <p class="packaging-p indent">Il foglio per contenitori, chiamato anche foglio lubrificato, viene utilizzato per la produzione di contenitori in alluminio, offrendo alcune delle più versatili soluzioni di imballaggio oggi disponibili. Con le sue proprietà uniche: barriera al 100% contro luce e gas, conducibilità termica, formabilità, capacità di contatto con gli alimenti e aspetto decorativo, aiuta a prevenire gli sprechi alimentari e fornisce al consumatore finale altri grandi benefici lungo la catena alimentare.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_3.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-3">Foglio per l’imballaggio</h4>
      <p class="packaging-p indent">Una combinazione unica di caratteristiche fisiche rende il foglio di alluminio un materiale essenziale per l'industria dell'imballaggio flessibile per la produzione di cartoni asettici, involucri, sacchetti, colli di bottiglia, blister farmaceutici, tubi laminati.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_4.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-4">Fogli Omnia</h4>
      <p class="packaging-p indent">Uno speciale tipo di fogli sviluppato dal predecessore di Alcomet, Alumina, utilizzato per la produzione di tappi di vasetti di tipo Omnia per la conservazione degli alimenti in condizioni casalinghe.</p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["packaging-1", "Foglio per la conservazione domestica degli alimenti (HHF)"],
        ["packaging-2", "Foglio per contenitori"],
        ["packaging-3", "Foglio per l’imballaggio"],
        ["packaging-4", "Fogli Omnia"]
      ]
    };
  }
};
</script>

<style scoped>
.packaging-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.packaging-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.packaging-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.packaging-link {
  font-size: 19px;
  text-decoration: underline;
}
.packaging-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.packaging-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .packaging-content {
    width: 100%;
  }
  .packaging-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .packaging-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .packaging-link {
    font-size: 16px;
  }
  .packaging-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Packaging.vue